function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { GENERATE_REPORT_ASYNC_REQUEST, GENERATE_REPORT_ASYNC_SUCCESS, GENERATE_REPORT_ASYNC_FAILURE, RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC, GENERATE_PRESIGNED_URL_REQUEST, GENERATE_PRESIGNED_URL_SUCCESS, GENERATE_PRESIGNED_URL_FAILURE, SET_DDU_LIST, FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS, FETCH_DATA_FROM_PRESIGNED_URL_REQUEST } from "../../actions/types";
export var initialState = {
    reportValue: [],
    generateReportError: false,
    isTriggerGenerateReport: false,
    presignedURL: "",
    generatePresignedURLError: false,
    dduList: [],
    csvData: "",
    isTriggerFetchDataFromPresignedURL: false
};
export function generateReportReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _ref = arguments.length > 1 ? arguments[1] : void 0, type = _ref.type, payload = _ref.payload;
    switch(type){
        case GENERATE_REPORT_ASYNC_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    generateReportError: false,
                    reportValue: [],
                    isTriggerGenerateReport: false
                });
            }
        case GENERATE_REPORT_ASYNC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    reportValue: payload,
                    isTriggerGenerateReport: true
                });
            }
        case GENERATE_REPORT_ASYNC_FAILURE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    generateReportError: true,
                    reportValue: [],
                    isTriggerGenerateReport: true
                });
            }
        case RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    generateReportError: false,
                    isTriggerGenerateReport: false
                });
            }
        case GENERATE_PRESIGNED_URL_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    presignedURL: "",
                    generatePresignedURLError: false
                });
            }
        case GENERATE_PRESIGNED_URL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    presignedURL: payload
                });
            }
        case GENERATE_PRESIGNED_URL_FAILURE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    generatePresignedURLError: true
                });
            }
        case SET_DDU_LIST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    dduList: payload
                });
            }
        case FETCH_DATA_FROM_PRESIGNED_URL_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    csvData: "",
                    isTriggerFetchDataFromPresignedURL: true
                });
            }
        case FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    csvData: payload,
                    isTriggerFetchDataFromPresignedURL: false
                });
            }
        default:
            {
                return state;
            }
    }
}

//# sourceMappingURL=index.js.map